export default "__VITE_ASSET__7d318ff2__"